var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79107 8.15954L15.2089 8.15954C15.5077 8.15954 15.75 8.44868 15.75 8.80574C15.75 9.1628 15.5077 9.45194 15.2089 9.45194L2.79107 9.45224C2.49235 9.45224 2.25 9.1631 2.25 8.80604C2.24975 8.44868 2.49235 8.15954 2.79107 8.15954Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43325 3.54808C6.60186 3.54808 6.76988 3.6136 6.89641 3.74375C7.14557 3.99982 7.13956 4.40858 6.88379 4.65775L2.59359 8.83161L6.90995 13.5423C7.15159 13.8056 7.13356 14.2143 6.87027 14.4554C6.60758 14.6958 6.19732 14.679 5.95719 14.4154L1.21711 9.24221C0.980573 8.98463 0.992591 8.58609 1.24296 8.34267L5.98281 3.73116C6.10814 3.60884 6.27104 3.54812 6.43335 3.54812L6.43325 3.54808Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationLeft);
export default __webpack_public_path__ + "static/media/navigation-left.4c3f3de40db62009ac2e0af86c813e5b.svg";
export { ForwardRef as ReactComponent };